import { createContext } from "react";
function doNothing() {
    return new Promise(() => {
        console.warn("doNothing called in CsAttributeApi: will never resolve");
    });
}
export const CsAttributeApiContext = createContext({
    setValue: doNothing,
    setLocalValue: doNothing,
    setValueQuantity: doNothing,
    toggleOption: doNothing,
    resetAttribute: doNothing,
});
CsAttributeApiContext.displayName = "CsAttributeApiContext";
//# sourceMappingURL=CsAttributeApiContext.js.map